import './DragDropTouch'; // https://github.com/Bernardo-Castilho/dragdroptouch 11th August 2016